import _ from 'lodash'

import moment from 'moment'

import { eventEmitter } from '@/event-bus'

import AuthService from '@/services/admin/AuthService.js'
import UserService from '@/services/admin/UserService.js'

import { AUTH_ERROR_MESSAGES } from '@/constants/errorMessages'

export const namespaced = true

export const state = {
  permissions: [],
  user: null,
  token: null,
  isAdmin: false,
  unread_notifications: [],
  unseen_notification_count: '0',
  nextRoute: null
}

export const getters = {
  token: state => {
    return state.token ? state.token : localStorage.getItem('user_access_token')
  },
  getNextRoute: state => {
    return state.nextRoute
  }
}

export const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
    localStorage.setItem('user_access_token', token)
  },
  LOGOUT(state, path) {
    localStorage.removeItem('user_access_token')
    if (path) {
      localStorage.setItem('next_route_admin', path)
    }
    location.reload()
  },
  SET_USER(state, user) {
    state.user = user
    state.isAdmin = user.is_admin
    state.unread_notifications = user.unread_notifications
    _.forEach(user.roles, role => {
      _.forEach(role.permissions, permission => {
        state.permissions.push(permission.name)
      })
    })

    Echo.connector.options.auth.headers['Authorization'] = 'Bearer ' + localStorage.getItem('user_access_token')
  },
  SET_UNREAD_NOTIFICATIONS(state, notifications) {
    state.unread_notifications = notifications
  },
  SET_UNSEEN_NOTIFICATION_COUNT(state, count) {
    state.unseen_notification_count = count
  },
  ADD_NOTIFICATION(state, notification) {
    state.unread_notifications.unshift(notification)
    state.unseen_notification_count++
  },
  SET_NEXT_ROUTE(state, path) {
    state.nextRoute = path
  }
}

export const actions = {
  getUser({ commit, dispatch, state }, force) {
    if (state.user && !force) {
      return state.user
    }

    return new Promise(resolve => {
      AuthService.getUser().then(response => {
        commit('SET_USER', response.data)

        dispatch('subscribeToChannel')

        resolve(response.data)
      })
    })
  },
  login({ commit, dispatch }, user) {
    return new Promise((resolve, reject) => {
      // The Promise used for router redirect in login

      AuthService.login(user)
        .then(response => {
          commit('SET_TOKEN', response.access_token)
          commit('SET_USER', response.user)

          dispatch('subscribeToChannel')

          resolve(response.user)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: AUTH_ERROR_MESSAGES.loginError + err
          }
          dispatch('notification/add', notification, {
            root: true
          })

          delete localStorage.clear() // if the request fails, remove any possible user token if possible
          reject(err)
        })
    })
  },
  verify({ commit, dispatch }, code) {
    return new Promise((resolve, reject) => {
      // The Promise used for router redirect in login

      AuthService.verify(code)
        .then(response => {
          commit('SET_TOKEN', response.access_token)
          commit('SET_USER', response.user)
          resolve(response.user)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: AUTH_ERROR_MESSAGES.verifyError
          }
          dispatch('notification/add', notification, {
            root: true
          })

          reject(err)
        })
    })
  },
  logout({ commit, dispatch }) {
    AuthService.logout().then(() => {
      dispatch('unsubscribeFromChannel')
      commit('LOGOUT').catch(err => {
        const notification = {
          type: 'danger',
          message: AUTH_ERROR_MESSAGES.logoutError + err
        }
        store.dispatch('notification/add', notification)
      })
    })
  },
  getNotifications({ commit, state }) {
    UserService.getNotifications(state.user.id).then(response => {
      commit('SET_UNREAD_NOTIFICATIONS', response.data)
      commit('SET_UNSEEN_NOTIFICATION_COUNT', response.meta.unseen_notification_count)
    })
  },
  markAsReadNotifications({ commit, state }) {
    UserService.markAsReadNotifications(state.user.id).then(() => {
      commit('SET_UNREAD_NOTIFICATIONS', [])
    })
  },
  markAsReadNotification({ commit, state }, id) {
    UserService.markAsReadNotification(state.user.id, id).then(() => {
      commit('REMOVE_NOTIFICATION', id)
    })
  },
  markAsSeenNotifications({ commit, state }) {
    UserService.markAsSeenNotifications(state.user.id).then(() => {
      commit('SET_UNSEEN_NOTIFICATION_COUNT', 0)
    })
  },
  addNotification({ commit }, notification) {
    let content = {
      data: {},
      created_at: moment()
    }
    _.forEach(notification, (n, k) => {
      if (k == 'id' || k == 'type') {
        content[k] = n
      } else {
        content.data[k] = n
      }
    })
    commit('ADD_NOTIFICATION', content)
  },
  subscribeToChannel({ state, dispatch }) {
    Echo.private('App.Models.User.' + state.user.id).notification(notification => {
      const notificationContent = {
        type: 'info',
        message: notification?.message
      }
      dispatch('notification/add', notificationContent, {
        root: true
      })
      dispatch('addNotification', notification)

      if (notification.type === 'App\\Models\\FarmerGtsRequestCompleted') {
        dispatch('adminFarmer/getGtsData', notification.farmer_id)
        eventEmitter.emit('gtsRequestCompleted')
      }
    })
  },
  unsubscribeFromChannel({ state }) {
    Echo.leave('App.Models.User.' + state.user.id)
  }
}
